import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { formatApiError } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { TestBadge } from "@/components/TestMode";

// Trainer details (shared Contacts record) + the horses this trainer is linked to.
export function TrainerContact({ d, onSaved }) {
  const navigate = useNavigate();
  const [f, setF] = useState({ name: d.name || "", phone: d.phone || "", email: d.email || "" });
  const [busy, setBusy] = useState(false);
  const editable = !d.registered;
  const save = () => {
    setBusy(true);
    api.patch(`/admin/contacts/trainer/${d.trainer_contact_id}`, f).then(() => { toast.success("Trainer contact saved"); onSaved(); })
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail) || "Could not save")).finally(() => setBusy(false));
  };
  const open = (h) => navigate(h.application_id ? `/applications/${h.application_id}` : `/horse/${h.horse_id}`);
  return (
    <section data-testid="contact-trainer-section" className="rounded-xl border border-sky-200 bg-sky-50/50 p-3 space-y-3">
      <h3 className="text-sm font-semibold">Trainer · {d.registered ? "Registered account" : "Contact only"}</h3>
      {editable && (
        <div className="grid sm:grid-cols-3 gap-2">
          <Input data-testid="trainer-edit-name" aria-label="Trainer name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Name" />
          <Input data-testid="trainer-edit-phone" aria-label="Trainer phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} placeholder="Phone" />
          <Input data-testid="trainer-edit-email" aria-label="Trainer email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="Email (optional)" />
          <Button data-testid="trainer-edit-save" onClick={save} disabled={busy} variant="outline" className="sm:col-span-3 h-10">Save trainer details</Button>
        </div>
      )}
      <div>
        <p className="text-xs font-semibold text-stone-600 mb-1">Associated horses ({d.trainer_horses.length})</p>
        {d.trainer_horses.length ? (
          <ul data-testid="contact-trainer-horses" className="space-y-1">{d.trainer_horses.map((h, i) => (
            <li key={i}><button type="button" onClick={() => open(h)} className="w-full text-left rounded-lg border border-stone-200 bg-white px-2.5 py-2 text-xs hover:bg-stone-50 flex items-center gap-1.5">
              {h.is_test && <TestBadge />}<span className="font-semibold">{h.name || "Unnamed horse"}</span>{h.status && <span className="text-stone-500">· {h.status.replace(/_/g, " ")}</span>}</button></li>
          ))}</ul>
        ) : <p className="text-xs text-stone-500">No horses linked yet.</p>}
      </div>
    </section>
  );
}
